import { ProductsState } from '../types/ProductsState'

export const state: ProductsState = {
  products: [],
  releasedProducts: [],
}
